import React, {Suspense, lazy} from 'react';
import {ROUTE_LEAVE_APPROVAL} from '../../RoutePathConstant';
import {authLoader} from '../../loader';
import {Spin} from 'antd';

const LeaveApproval = lazy(() =>
  import('../../../screens/LeaveApproval')
    .then(module => ({default: module.LeaveApproval})));

const LeaveApprovalNavigation = [
  {
    path: ROUTE_LEAVE_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <LeaveApproval />
      </Suspense>
    ),
  },
];

export default LeaveApprovalNavigation;
